import '../../../public/fonts/Inter/inter.module.css';
import AuthRoute from '../../auth-route';
import IndexLayout from './index.layout';
import LoginLayout from './sign-in.layout';
import { useDispatch, useSelector } from 'react-redux';
import {
  getUserByGoogleToken,
  clearRegisterData,
  clearErrors,
  getUserByAppleToken,
} from '../../../redux/slices/user';
import { useState, useEffect } from 'react';
import CustomAlert from '../../alert';
import { alertType } from '../../../constans/alert';
import { pageType } from '../../../constans/signin';
import { useRouter } from 'next/router';

export const SignInLayout = ({
  authData,
  handleInputChange,
  onLogin,
  handleErrorData,
  handleKeyPress,
  handleChurchChange,
  churchInfo,
}) => {
  const dispatch = useDispatch();
  const { error } = useSelector((store) => store.user);

  const [page, setPage] = useState(pageType.signin);
  const [alert, setAlert] = useState({
    open: false,
    alertType: '',
    text: '',
  });
  const router = useRouter();
  useEffect(() => {
    dispatch(clearRegisterData());
    dispatch(clearErrors());

    setAlert({
      open: false,
      alertType: '',
      text: '',
    });
  }, []);

  useEffect(() => {
    if (router.query.loginStep) {
      setPage(pageType.login);
    }
  }, [router.query])

  useEffect(() => {
    const getErr = async () => {
      await handleClearAlert();
      error?.length > 0 &&
        setAlert({
          open: true,
          alertType: alertType.WARNING,
          text: error[0].value ? error[0].value : error[0],
        });
    };
    getErr();
  }, [error]);

  const handleClearAlert = () => {
    setAlert({
      open: false,
      alertType: '',
      text: '',
    });
  };

  const appleSignIn = (accessToken) => {
    dispatch(
      getUserByAppleToken({
        access_token: accessToken,
        church_id: churchInfo.id,
      })
    );
  };

  const googleSignIn = (accessToken) => {
    dispatch(
      getUserByGoogleToken({
        access_token: accessToken,
        church_id: churchInfo.id,
      })
    );
  };

  const handlePage = (state) => setPage(state);

  return (
    <>
      {page === pageType.login ? (
        <LoginLayout
          handlePage={handlePage}
          authData={authData}
          handleInputChange={handleInputChange}
          onLogin={onLogin}
          handleKeyPress={handleKeyPress}
          churchInfo={churchInfo}
          handleErrorData={handleErrorData}
        />
      ) : (
        <IndexLayout
          googleSignIn={googleSignIn}
          appleSignIn={appleSignIn}
          handleErrorData={handleErrorData}
          handlePage={handlePage}
          handleChurchChange={handleChurchChange}
          churchInfo={churchInfo}
        />
      )}
      {alert.open && (
        <CustomAlert
          open={alert.open}
          alertType={alert.alertType}
          text={alert.text}
        />
      )}
    </>
  );
};
